import { useEffect } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router';
import { privateRoutes } from './private-routes';
import { ProtectedRoute } from './protected-route';
import { AuthGate } from './protected-route/auth-gate';
import { publicRoutes } from './public-routes';
import { Layout } from '@/components/layout';
import { RouterNavigationProvider } from '@/hooks/use-navigation/router-navigation';

export const AppRoutes = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <RouterNavigationProvider>
      <Routes>
        {Object.values(publicRoutes).map(({ path, element }) => {
          const Element = element;
          return <Route key={path} path={`${path}/*`} element={<Element />} />;
        })}

        <Route element={<AuthGate />}>
          <Route element={<Layout />}>
            {Object.values(privateRoutes).map((route) => {
              const Element = route.element;

              if (route.home) {
                return (
                  <Route
                    key="/"
                    index
                    element={
                      <ProtectedRoute route={route}>
                        <Element />
                      </ProtectedRoute>
                    }
                  />
                );
              }

              return (
                <Route
                  key={route.path}
                  path={`${route.path}/*`}
                  element={
                    <ProtectedRoute route={route}>
                      <Element />
                    </ProtectedRoute>
                  }
                />
              );
            })}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Route>
      </Routes>
    </RouterNavigationProvider>
  );
};
